import React from 'react'
import { isFieldResponseAvailable } from '../utils/fieldUtils'
import { UnionFieldModelType, UnionFieldResponseType } from '../types/Field'
import { requiredFieldResponse } from './fieldValidations'

interface ValidationReturnType {
   isValid: boolean
   errorMessage: string | undefined
}

interface ReturnType {
   validate: (
      fieldResponse: UnionFieldResponseType,
      fieldResponseId: string,
      field: UnionFieldModelType,
      required: boolean | null | undefined
   ) => ValidationReturnType
}
export const validateFieldResponse = (): ReturnType => {
   const doRequiredFieldValidation = (
      isRequired: boolean | null | undefined
   ) => {
      const required = isRequired

      if (required) {
         return {
            isValid: false,
            errorMessage: requiredFieldResponse().errorMessage
         }
      }
      return {
         isValid: true,
         errorMessage: undefined
      }
   }

   const doWritableFieldValidation = (
      fieldResponse: UnionFieldResponseType,
      fieldResponseId: string,
      field: UnionFieldModelType,
      required: boolean | null | undefined
   ): ValidationReturnType => {
      const response = {
         fieldResponseId,
         fieldId: field.fieldId,
         fieldType: field.fieldType as any,
         response: fieldResponse as any
      }

      if (isFieldResponseAvailable(response)) {
         const validationResponse = field.validate(fieldResponse as any) //FIXME:update this properly
         return {
            isValid: validationResponse.isValid,
            errorMessage: validationResponse.errorMessage
         }
      }
      return doRequiredFieldValidation(required)
   }

   const validate = (
      fieldResponse: UnionFieldResponseType,
      fieldResponseId: string,
      field: UnionFieldModelType,
      required: boolean | null | undefined
   ): ValidationReturnType => {
      const { isWritable } = field

      if (isWritable) {
         return doWritableFieldValidation(
            fieldResponse,
            fieldResponseId,
            field,
            required
         )
      }
      return {
         isValid: true,
         errorMessage: undefined
      }
   }

   return {
      validate
   }
}
